<template>
	<div class="login__content">
		<router-link v-bind:to="'/'">
			<h1>Mandato Aberto</h1>
		</router-link>

		<form role="form" @submit.prevent="requestEmail" class="form--login">
			<div class="form__group">
				<input type="email" placeholder="Digite seu e-mail" v-model="formEmailPasswordReset.email">
				<ul class="validation" v-show="errorForm(error, 'email')">
					<li class="validation__error">{{ 'email-invalid' | translate | capitalize }}</li>
				</ul>
			</div>
			<div class="form__validation--success" v-show="successMsg">
				<p><i class="fa fa-check"></i> {{ 'email send' | translate | capitalize }}</p>
			</div>
			<div class="form__group submit__content">
				<button type="submit">{{ 'send'  | translate  | capitalize }}</button>
			</div>
		</form>

	</div>
</template>

<script>

	import error from '../../methods/errors';

	export default {
		name: 'reset-password-email',
		data() {
			return {
				formEmailPasswordReset: {
					email: '',
				},
				successMsg: false,
				error: {
					approved: false,
				},
			};
		},
		watch: {
			/* eslint-disable object-shorthand */
			errors() {
				this.error = this.$store.state.error;
			},
		},
		computed: {
			errors() {
				return this.$store.state.error;
			},
			success() {
				return this.$store.state.status;
			},
		},
		methods: {
			requestEmail() {
				this.$store.dispatch('emailPasswordReset', this.formEmailPasswordReset.email).then(() => {
					this.validate();
				});
			},
			errorForm(obj, field) {
				const msg = error.errorForm(obj, field);
				return msg;
			},
			validate() {
				if (this.success) {
					this.successMsg = this.success;
					this.$data.formEmailPasswordReset = {};
				}
			},
		},
	};
</script>



// WEBPACK FOOTER //
// _source/javascripts/components/reset-password/resetPasswordEmail.vue